import { phoneHref } from "@/lib/data";

const TICKS = ["Free no-obligation quotes", "Fully insured specialist", "Domestic & commercial cleans"];

export default function Hero({ content }) {
  const phone = content?.phone || "07378114330";
  return (
    <section className="relative bg-[#070b12] text-[#f0f4f8] pt-16 pb-24 md:pt-24 md:pb-32 overflow-hidden border-b border-[#1e9bff]/15" data-testid="hero-section">
      <div
        className="absolute inset-0 opacity-25 sy-drift pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 30%, rgba(30,155,255,0.28) 0%, transparent 45%), radial-gradient(circle at 80% 70%, rgba(30,155,255,0.18) 0%, transparent 50%)",
          backgroundSize: "140% 140%",
        }}
      />
      <div className="max-w-6xl mx-auto px-4 relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
        <div className="lg:col-span-8 min-w-0">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-[#1e9bff]/30 bg-[#1e9bff]/10 text-[#1e9bff] text-xs font-mono-lbl uppercase tracking-[0.14em] mb-6">
            <span>Residential &amp; Commercial</span>
          </div>
          <h1 className="font-display uppercase text-white leading-[0.92] tracking-tight text-[clamp(36px,5vw,72px)] mb-6" data-testid="hero-headline">
            <span className="sy-ln"><span>Keeping South Yorkshire&rsquo;s</span></span>
            <span className="sy-ln"><span className="text-[#1e9bff]">Exteriors Spotless</span></span>
          </h1>
          <p className="font-script text-[#9fd2ff] text-2xl md:text-3xl mb-8 -rotate-1 origin-left" data-testid="hero-tagline">
            &ldquo;{content?.tagline || "Keeping South Yorkshire's Exteriors Spotless"}&rdquo;
          </p>
          <div className="sy-fade-1 flex flex-wrap items-center gap-4">
            <a
              href="#booking"
              data-testid="hero-book-btn"
              className="px-7 py-4 rounded-xl bg-[#1e9bff] text-black font-display text-lg uppercase tracking-wider hover:bg-[#6ec2ff] hover:shadow-[0_0_30px_rgba(30,155,255,0.6)] transition-colors"
            >
              Book a Clean
            </a>
            <a
              href={phoneHref(phone)}
              data-testid="hero-call-btn"
              className="px-6 py-4 rounded-xl border border-white/20 bg-white/5 hover:bg-white/10 text-white font-mono-lbl text-xs uppercase tracking-widest transition-colors"
            >
              Call {phone}
            </a>
          </div>
        </div>
        <div className="lg:col-span-4 min-w-0 sy-fade-2">
          <div className="p-6 rounded-2xl bg-[#0c1322] border border-[#1e9bff]/30 relative overflow-hidden sy-glow-deep">
            <div className="flex items-center justify-between mb-4 pb-3 border-b border-white/10 font-mono-lbl text-xs text-[#93b4d4] uppercase tracking-widest">
              <span>South Yorkshire Direct Line</span>
              <span className="text-[#1e9bff]">Active</span>
            </div>
            <div className="space-y-3 text-sm text-[#c8d9ea]">
              {TICKS.map((t) => (
                <div key={t} className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#1e9bff]"></span>
                  <span>{t}</span>
                </div>
              ))}
            </div>
            <div className="mt-6 pt-4 border-t border-white/10 flex items-center justify-between gap-2">
              <span className="text-xs font-mono-lbl text-[#93b4d4]">Email Bookings</span>
              <span className="text-[11px] font-mono-lbl text-white truncate" data-testid="hero-email">{content?.email}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
